import Hammer from 'hammerjs'; // Touch-events library
import { TimelineMax } from 'gsap';

Vue.component('context-slider', {
    props: ['slides'],

    data() {
        return {
            transitionSpeed: 0.6,
            topOffset: null,
            bottomOffset: null,

            // Third-party
            hammertime: null,
            activeIndex: 0,
            backwards: false,
            inTransition: false,
        };
    },

    computed: {
        // a computed getter
        previousIndex() {
            if (this.activeIndex > 0) {
                return this.activeIndex - 1;
            }

            return this.slides.length - 1;
        },

        nextIndex() {
            if (this.activeIndex < (this.slides.length - 1)) {
                return this.activeIndex + 1;
            }

            return 0;
        },
    },

    created() {
        document.documentElement.classList.add('full-screen');
    },

    mounted() {
        // Lister for user scroll down, which fires the 'user-scroll-down' Event
        this.$root.listenForScroll();

        EventBus.$on('user-scroll-down', () => {
            this.next();
        });

        EventBus.$on('user-scroll-up', () => {
            this.previous();
        });

        this.loadSwipeEvents();
        document.addEventListener('keyup', this.keyEvents);

        Vue.nextTick(() => {
            this.calculateSliderOffsets();
            TweenMax.set(['.navigation', '.pagination .divider'], { scaleY: 0 });
            TweenMax.set('.pagination .current .movement-container', { x: '100%' });
            TweenMax.set('.pagination .total .movement-container', { x: '-100%' });
            TweenMax.set(['.context-items .previous', '.context-items .next'], { autoAlpha: 0 });

            TweenMax.set('.context-items .active .title', { autoAlpha: 0, x: '15%' });
            TweenMax.set('.context-items .active .excerpt', { autoAlpha: 0, x: '25%' });

            TweenMax.set('.active.context-item .subline .movement-container', { y: '100%' });
            TweenMax.set('.active.context-item .read-more', { autoAlpha: 0 });

            const tl = new TimelineMax({ paused: true, delay: 2 });

            tl.to(['.navigation', '.pagination .divider'], 1, { scaleY: 1 });
            tl.to('.pagination .current .movement-container', 1, { x: '0%' }, 1);
            tl.to('.pagination .total .movement-container', 1, { x: '0%' }, 1);
            tl.to('.context-items .active .title', 1, { autoAlpha: 1, x: '0%' }, 1);
            tl.to('.context-items .active .excerpt', 1, { autoAlpha: 1, x: '0%' }, 1.1);
            tl.to(['.context-items .previous', '.context-items .next'], 1, { autoAlpha: 1 }, 1.1);

            tl.to('.active.context-item .subline .movement-container', 1, { y: '0%' }, 1.5);
            tl.to('.active.context-item .read-more', 1, { autoAlpha: 1 }, 1.5);

            window.requestAnimationFrame(() => {
                tl.play();
            });
        });

        EventBus.$on('window-resize', this.calculateSliderOffsets);
    },

    methods: {
        /**
         * Calculates the previous item top offset to be used
         * by the slider animation logic.
         *
         * @returns {Void}
         */
        calculateSliderOffsets() {
            const topRect = document.querySelector('.previous.context-item').getBoundingClientRect();
            const bottomRect = document.querySelector('.next.context-item').getBoundingClientRect();
            const parentRect = document.querySelector('.context-items').getBoundingClientRect();

            this.topOffset = topRect.top - parentRect.top;
            this.bottomOffset = bottomRect.top - parentRect.top;
        },

        /**
         * Load the swipe events for this component.
         *
         * @return {void}
         */
        loadSwipeEvents() {
            this.hammertime = new Hammer(this.$el, {});
            this.hammertime.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });

            this.hammertime.on('swipeup', (ev) => {
                this.next();
            });

            this.hammertime.on('swipedown', (ev) => {
                this.previous();
            });
        },

        transitionToContext() {
            this.$root.router.transition = this.$root.router.transitions.ContextSliderToWork;

            page(this.slides[this.activeIndex].url);
        },

        next() {
            if (this.inTransition) {
                return;
            }

            this.inTransition = true;
            this.backwards = false;

            const nextIndex = this.activeIndex + 1;

            if (nextIndex > this.slides.length - 1) {
                this.activeIndex = 0;
                return;
            }

            this.activeIndex = nextIndex;
        },

        previous() {
            if (this.inTransition) {
                return;
            }

            this.inTransition = true;
            this.backwards = true;

            const previousIndex = this.activeIndex - 1;

            if (previousIndex < 0) {
                this.activeIndex = this.slides.length - 1;
                return;
            }

            this.activeIndex = previousIndex;
        },

        // --------
        // Previous: ENTERING
        // --------
        beforePreviousEnter(el) {
            if (this.backwards) {
                TweenMax.set(el, { autoAlpha: 0, y: '-100%' });
                return;
            }

            TweenMax.set(el, { autoAlpha: 0 });
        },

        // the done callback is optional when
        // used in combination with CSS
        previousEnter(el, done) {
            if (this.backwards) {
                TweenMax.to(el, this.transitionSpeed, { autoAlpha: 1, y: '0%', onComplete: done });
                return;
            }

            TweenMax.delayedCall(this.transitionSpeed, done);
        },

        afterPreviousEnter(el) {
            TweenMax.set(el, { autoAlpha: 1 });
        },

        previousEnterCancelled(el) {
            // ...
        },

        // --------
        // Previous: Leaving
        // --------

        beforePreviousLeave(el) {
            // ...
        },

        previousLeave(el, done) {
            if (this.backwards) {
                const first = el.getBoundingClientRect();

                TweenMax.set(el, { top: '50%', y: '-50%', marginTop: 0 });

                const last = el.getBoundingClientRect();
                const invert = first.top - last.top;

                TweenMax.set(el, { y: invert });

                TweenMax.to(el, this.transitionSpeed, { y: 0, onComplete: done });
                TweenMax.to(el.querySelector('.title'), this.transitionSpeed, { scale: 1, transformOrigin: 'left top', color: '#d05631' });
                TweenMax.to([el.querySelector('.subline'), el.querySelector('.excerpt'), el.querySelector('.read-more')], 0.4, { autoAlpha: 1, delay: 0.1 });

                return;
            }

            TweenMax.to(el, this.transitionSpeed, { autoAlpha: 0, y: '-100%', onComplete: done });
        },

        afterPreviousLeave(el) {
            TweenMax.set(el, { autoAlpha: 0 });
        },

        previousLeaveCancelled(el) {
            // ...
        },

        // --------
        // Active: ENTERING
        // --------

        beforeActiveEnter(el) {
            TweenMax.set(el, { autoAlpha: 0 });
        },

        // the done callback is optional when
        // used in combination with CSS
        activeEnter(el, done) {
            TweenMax.delayedCall(this.transitionSpeed, done);
        },

        afterActiveEnter(el) {
            TweenMax.set(el, { autoAlpha: 1 });

            this.inTransition = false;
        },

        activeEnterCancelled(el) {
            // ...
        },

        // --------
        // Active: LEAVING
        // --------

        beforeActiveLeave(el) {
            // ...
        },

        // the done callback is optional when
        // used in combination with CSS
        activeLeave(el, done) {
            const first = el.getBoundingClientRect();

            if (this.backwards) {
                TweenMax.set(el, { top: this.bottomOffset, y: '0%' });
            } else {
                TweenMax.set(el, { top: this.topOffset, y: '0%' });
            }

            const last = el.getBoundingClientRect();
            const invert = first.top - last.top;

            TweenMax.set(el, { y: invert });

            if (this.backwards) {
                TweenMax.to(el, this.transitionSpeed, { y: '0%', onComplete: done });
                TweenMax.to(el.querySelector('.title'), this.transitionSpeed, { scale: 0.7, transformOrigin: 'left top', color: 'rgba(255, 255, 255, 0.1)' });
                TweenMax.to([el.querySelector('.subline'), el.querySelector('.excerpt'), el.querySelector('.read-more')], 0.4, { autoAlpha: 0 });

                return;
            }

            TweenMax.to(el, this.transitionSpeed, { y: '0%', onComplete: done });
            TweenMax.to(el.querySelector('.title'), this.transitionSpeed, { scale: 0.7, transformOrigin: 'left top', color: 'rgba(255, 255, 255, 0.1)' });
            TweenMax.to([el.querySelector('.subline'), el.querySelector('.excerpt'), el.querySelector('.read-more')], 0.4, { autoAlpha: 0 });
        },

        afterActiveLeave(el) {
            TweenMax.set(el, { autoAlpha: 0 });
        },

        // leaveCancelled only available with v-show
        activeLeaveCancelled(el) {
            // ...
        },

        // --------
        // Next: ENTERING
        // --------

        beforeNextEnter(el) {
            if (this.backwards) {
                TweenMax.set(el, { autoAlpha: 0 });

                return;
            }

            TweenMax.set(el, { autoAlpha: 0, y: '150%' });
        },

        nextEnter(el, done) {
            if (this.backwards) {
                TweenMax.delayedCall(this.transitionSpeed, done);
                return;
            }
            TweenMax.to(el, this.transitionSpeed, { autoAlpha: 1, y: '0%', onComplete: done });
        },

        afterNextEnter(el) {
            TweenMax.set(el, { autoAlpha: 1 });
        },

        // leaveCancelled only available with v-show
        nextEnterCancelled(el) {
            // ...
        },

        // --------
        // Next: LEAVING
        // --------

        beforeNextLeave(el) {
            // ...
        },

        nextLeave(el, done) {
            if (this.backwards) {
                TweenMax.to(el, this.transitionSpeed, { autoAlpha: 0, y: '100%', onComplete: done });
                return;
            }

            const first = el.getBoundingClientRect();

            TweenMax.set(el, { top: '50%', y: '-50%' });

            const last = el.getBoundingClientRect();
            const invert = first.top - last.top;

            TweenMax.set(el, { y: invert });

            TweenMax.to(el, this.transitionSpeed, { y: 0, onComplete: done });
            TweenMax.to(el.querySelector('.title'), this.transitionSpeed, { scale: 1, transformOrigin: 'left top', color: '#d05631' });
            TweenMax.to([el.querySelector('.subline'), el.querySelector('.excerpt'), el.querySelector('.read-more')], 0.4, { autoAlpha: 1, delay: 0.1 });
        },

        afterNextLeave(el) {
            TweenMax.set(el, { autoAlpha: 0 });
        },

        // leaveCancelled only available with v-show
        nextLeaveCancelled(el) {
            // ...
        },

        /**
         * Initialize keyevents on the document
         *
         * @return {void}
         */
        keyEvents(e) {
            switch (e.keyCode) {
            // Up
            case 38:
                this.previous();
                break;
                // Down
            case 40:
                this.next();
                break;
            default:
                // Nothing
            }
        },

    },

    beforeDestroy() {
        this.$root.removeScrollListener();

        EventBus.$off('user-scroll-down');
        EventBus.$off('user-scroll-up');

        this.hammertime.destroy();

        document.removeEventListener('keyup', this.keyEvents);

        EventBus.$off('window-resize', this.calculateSliderOffsets);

        // Clear all TweenMax properties
        TweenMax.set([
            '.navigation',
            '.pagination .divider',
            '.pagination .current .movement-container',
            '.pagination .total .movement-container',
            '.context-item',
            '.context-items .previous',
            '.context-items .next',
            '.context-items .active .title',
            '.context-items .active .excerpt',
            '.active.context-item .subline .movement-container',
            '.active.context-item .read-more',
        ], { clearProps: 'all' });
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/context-slider.js